// extracted by mini-css-extract-plugin
export default {"promotions":"Promotion_promotions__BC3UU","promotion":"Promotion_promotion__fQs8v","icon":"Promotion_icon__SkmpL","paras":"Promotion_paras__QoKj-"};